module.exports = __webpack_public_path__ + "img/horizontal_3_7_9006.dacc3af6.png";